<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import BaseButton from "@/common/components/BaseButton.vue";
import AnonymousLayout from "@/layouts/AnonymousLayout.vue";

definePage({
  meta: {
    layout: AnonymousLayout,
  },
});

const { t } = useI18n();

const router = useRouter();

const onReturn = () => {
  router.go(-1);
};
</script>

<template>
  <div class="flex flex-col justify-center items-center p-3 pt-32">
    <div class="font-bold text-lg py-2">
      {{ t("inboundReport.successPage.title") }}
    </div>
    <div class="text-gray-500 py-2 text-center">
      {{ t("inboundReport.successPage.info") }}
    </div>
    <BaseButton
      variant="primary"
      class="my-3 w-full md:w-1/2 md:my-8"
      :label="t('inboundReport.successPage.button')"
      @click="onReturn"
    />
  </div>
</template>
